import { Quote } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Shared";

export const Testimonials = () => (
  <section className="py-20 sm:py-28" data-testid="testimonials-section">
    <div className="max-w-6xl mx-auto px-6">
      <SectionHeading eyebrow="Case study example" title="What clients say." />
      <Reveal delay={0.1} className="mt-12 max-w-3xl mx-auto">
        <figure
          className="rounded-3xl border border-[#E9E4F0] bg-[#EDEDF1] p-8 sm:p-12 text-center"
          data-testid="testimonial-quote-card"
        >
          <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-full bg-violet-100 text-violet-700">
            <Quote className="h-5 w-5" />
          </span>
          <blockquote className="font-display mt-6 text-xl sm:text-2xl font-semibold leading-snug tracking-tight text-[#3B0764]">
            “In six weeks we went from chasing referrals to eleven live conversations with hiring
            managers. Two turned into retained tech roles inside the first month.”
          </blockquote>
          <figcaption className="mt-7 text-sm text-[#6B5CA5]">
            <span className="font-semibold text-[#3B0764]">Managing Director</span> · IT recruitment firm
            <span className="mt-1 block text-xs">Name and details shared on request</span>
          </figcaption>
        </figure>
      </Reveal>
    </div>
  </section>
);
